import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { css, cx } from 'emotion';
import IconButton from '@mui/material/IconButton';
import parse from 'html-react-parser';
import { Typography } from '@mui/material';
import { smallScreen, benefitContainer, logoContainer } from '../additional-benefits/product-components/shared-styles';
import { CaretUp, CaretDown } from 'phosphor-react';
import { posthogAttrs } from '../../../posthog-constants';

export class LimitedFSAPlanViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      learnMoreOpen: false,
      meaningsOpen: false,
    };
  }

  replaceURLWithHTMLLinks(text) {
    var exp = /(?:^|[^"'])((ftp|http|https|file):\/\/[\S]+(\b|$))/gi;
    return text.replace(exp, " <a href='$1' target='_blank'>$1</a>");
  }

  parseDisclaimer = (disclaimer) => {
    return parse(this.replaceURLWithHTMLLinks(disclaimer));
  };

  toggleLearnMore = () => {
    this.setState((prevState, props) => {
      return {
        learnMoreOpen: !prevState.learnMoreOpen,
      };
    });
  };

  getTitleDescription = () => {
    if (this.props.benefit && this.props.benefit.TitleDescriptions) {
      let customTitleDescriptions = [];
      for (let td of this.props.benefit.TitleDescriptions) {
        if (!td.Autogenerated) {
          customTitleDescriptions.push(td);
        }
      }
      return customTitleDescriptions;
    }
    return [];
  };

  hasTitleDescription = () => {
    return this.getTitleDescription().length > 0;
  };

  hasLogo = () => {
    if (this.props.carrier && this.props.carrier.LogoURL) {
      return true;
    }
    return false;
  };

  getLogo = () => {
    if (this.props.carrier && this.props.carrier.LogoURL) {
      return this.props.carrier.LogoURL;
    }
    return '';
  };

  render() {
    return (
      (<motion.div
        key={'limitedpurpose_question'}
        initial="pageInitial"
        animate="pageAnimate"
        exit="pageExit"
        variants={{
          pageInitial: {
            x: 400,
            opacity: 0,
          },
          pageAnimate: {
            x: 0,
            opacity: 1,
          },
          pageExit: {
            x: -400,
            opacity: 0,
          },
        }}
        className={cx(
          css`
            position: relative;
          `,
          benefitContainer
        )}
        style={{
          border: `4px solid ${
            this.props.designStyles?.Theme?.Body?.ButtonColor
              ? this.props.designStyles?.Theme?.Body?.ButtonColor
              : '#25282D'
          }`,
        }}
      >
        <div
          className={css`
            display: flex;
            justify-content: space-between;
            align-items: center;
          `}
        >
          <div
            className={css`
              margin-right: 16px;
              max-width: 66%;
              @media only screen and (max-width: 600px) {
                min-width: 140px;
              }
            `}
          >
            <div>
              <Typography
                style={{
                  fontSize: smallScreen ? '16px' : '18px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                  textAlign: smallScreen ? 'left' : 'center',
                }}
              >
                Limited Purpose FSA
              </Typography>
              <Typography
                className={css`
                  font-size: 12px;
                  margin: 0;
                  padding: 0;

                  margin-right: 40px;
                  text-align: left;
                  @media only screen and (max-width: 600px) {
                    display: none;
                  }
                `}
              >
                A healthcare spending account that can only be used for eligible vision and dental expenses.
              </Typography>
            </div>
          </div>
          <div
            className={cx(
              logoContainer,
              css`
                justify-content: center;
                align-items: center;
                ${smallScreen} {
                  flex-grow: 1;
                  justify-content: end;
                }
              `
            )}
          >
            {this.hasLogo() ? (
              <img
                src={this.getLogo()}
                alt="Carrier Logo"
                className={css`
                  max-height: 40px;
                  max-width: 100px;
                `}
              />
            ) : null}
          </div>
        </div>
        <div
          className={css`
            display: flex;
            align-items: center;
            @media only screen and (min-width: 600px) {
              display: none;
            }
          `}
        >
          <div
            className={css`
              font-size: 12px;
              margin: 0;
              padding: 0;
              flex-grow: 1;
              margin-right: 40px;
              text-align: left;
            `}
          >
            A healthcare spending account that can only be used for eligible vision and dental expenses.
          </div>
        </div>
        {this.state.learnMoreOpen && (
          <>
            <div
              className={css`
                text-align: left;
                font-weight: bold;
                padding: 16px;
              `}
            >
              You can contribute up to{' '}
              <span
                className={css`
                  font-weight: bold;
                `}
              >
                $3,300
              </span>{' '}
              annually in 2025.
            </div>
            <div>
              <div
                className={css`
                  text-align: left;
                  padding: 16px;
                  font-weight: bold;
                `}
              >
                How do I use my limited FSA money?
              </div>
              <div
                className={css`
                  text-align: left;
                  padding: 16px;
                `}
              >
                You (and your eligible dependents) can use these funds to pay for a variety of dental and vision
                expenses. The IRS determines what is eligible for reimbursement, but here are a few examples:
              </div>

              <ul
                className={css`
                  text-align: left;
                `}
              >
                <li>Contact lenses & solution</li>
                <li>Eye Exams</li>
                <li>Prescription eye glasses</li>
                <li>Dental coinsurance, copays, and deductibles</li>
                <li>Dental services</li>
                <li>Clear aligners</li>
                <li>And much more</li>
              </ul>
            </div>

            {this.hasTitleDescription() && (
              <>
                {this.getTitleDescription().map((td) => {
                  return (
                    <div
                      className={css`
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-right: 40px;
                        margin-left: 40px;
                        margin-bottom: 16px;
                        font-size: 12px;
                      `}
                    >
                      <div
                        className={css`
                          max-width: 40%;
                          text-align: left;
                        `}
                      >
                        {td.Title}
                      </div>
                      <div>
                        <div
                          className={css`
                            font-weight: bold;
                          `}
                        >
                          {td.Description}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
            {this.props.benefit.Disclaimer && (
              <div
                className={css`
                  font-size: 9px;
                  font-weight: 400;
                  margin: 16px;
                `}
              >
                {this.parseDisclaimer(this.props.benefit.Disclaimer)}
              </div>
            )}
          </>
        )}
        <div
          className={css`
            display: flex;
            justify-content: center;
            margin-bottom: -20px;
          `}
        >
          <IconButton
            aria-label="Learn more"
            onClick={() => this.toggleLearnMore()}
            data-ph-capture-attribute-source={posthogAttrs?.types?.RECOMMENDATIONS}
            data-ph-capture-attribute-action={posthogAttrs?.actions?.VIEW_MORE}
            data-ph-capture-attribute-product-type={this?.props.benefit?.Type}
            size="large">
            {!this.state.learnMoreOpen ? <CaretDown size={24} /> : <CaretUp size={24} />}
          </IconButton>
        </div>
      </motion.div>)
    );
  }
}
